<div class="content-pane">
  <h2>Edit Dataset Access</h2>
  <div class="meta-subheader lifted expanded-margin-bottom">
    Dataset: <a [routerLink]="pdeRoutes.datasetView(dataset().id)">{{ dataset().name }}</a>
  </div>
  <div>
    <app-permissions-table
      [context]="datasetPermissionContext"
      [rows]="datasetPermissions"
      (save)="modifyPermission($event)"
      (delete)="revokePermission($event)"
      (useSync)="modifyPermissionSync($event)"
      (changeOrgAccess)="modifyOrgAccess($event)"
      [useEmailDropdown]="useEmailDropdown()"
      [availableEmails]="availablePermissionEmails()"
    ></app-permissions-table>

    <div class="content-subsection half-margin-top half-margin-bottom">
      <h3 class="meta-subheader half-margin-bottom">Public Data Commons Dataset Details Visibility</h3>
      <form [formGroup]="visibilityForm">
        <mat-radio-group formControlName="visibility" class="flex flex-col">
          <mat-radio-button value="team"> Not visible in the Public Data Commons </mat-radio-button>

          <mat-radio-button value="public"> Visible in the Public Data Commons </mat-radio-button>
        </mat-radio-group>

        @if (dataset()?.visible_to_all_users && !project().visible_to_all_users) {
          <div class="alert-error">
            <b>Note:</b> The dataset won't be visible until the primary associated project,
            <a [routerLink]="pdeRoutes.projectView(project().id)" target="_blank">{{ project().name }}</a
            >, is also made visible in the Public Data Commons.
          </div>
        }
      </form>
    </div>
  </div>

  @if (canMakeFilesPublic() || dataset()?.is_data_public) {
    <div class="content-subsection standard-margin-top">
      <h3 class="meta-subheader half-margin-bottom">Public Data Commons Dataset File Visibility</h3>

      <form [formGroup]="fileVisibilityForm">
        <mat-radio-group formControlName="visibility" class="flex flex-col">
          <mat-radio-button value="team"> Not visible in the Public Data Commons </mat-radio-button>

          <mat-radio-button value="public"> Visible in the Public Data Commons </mat-radio-button>
        </mat-radio-group>
      </form>
      @if (syncProgress()) {
        <div class="progress-bar-container">
          <mat-progress-bar
            [mode]="
              syncProgress().isProcessingMetadata ? 'query' : syncProgress().isFinalizing ? 'indeterminate' : 'buffer'
            "
            [value]="((syncProgress().uploaded ?? 0) * 100) / (syncProgress().total ?? 1)"
            [bufferValue]="((syncProgress().downloaded ?? 0) * 100) / (syncProgress().total ?? 1)"
          ></mat-progress-bar>
        </div>
      }
    </div>
  }

  <div class="form-actions">
    <a matButton="filled" class="cancelbtn" [routerLink]="pdeRoutes.datasetView(dataset().id)">
      <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
      Back to Dataset
    </a>
  </div>
  @if (dataset()?._can_delete_meta) {
    <div class="content-subsection" appSubsectionScroll data-subsection="delete">
      <h3>Delete Dataset</h3>

      <button matButton="filled" type="button" class="danger subsection-action" (click)="deleteDataset()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
        Delete Dataset
      </button>
    </div>
  }
</div>
